export const user = state => state.user
export const menuTree = state => state.menuTree
export const menuClickInOtherPage = state => state.menuClickInOtherPage



// WEBPACK FOOTER //
// ./src/store/getters.js